import * as React from 'react';
import { IconButton, Avatar } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { Person } from '@mui/icons-material';

interface ProfileIconProps {
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const ProfileIcon: React.FC<ProfileIconProps> = ({onClick}) => {
    const {user} = useAuth0();
    const navigate = useNavigate();
    // return (
    //     <IconButton onClick={onClick} sx={{ p: 0 }}>
    //         <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
    //     </IconButton>
    // );
    return (
        <IconButton
          aria-label={'user'}
          // size="large"
          sx={{
            width: '35px',
            height: '35px',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            border: '0.5px solid rgba(97, 179, 255, 0.5)',
            color: '#61B3FF',
            borderRadius: '50%',
            padding: '10px',
          }}
          onClick={onClick}
        >
        {user ?
          <img
            src={user.picture}
            alt="Profile"
            style={{ width: '35px', height: '35px', borderRadius: '50%' }}
          />
          : 
         <Person sx={{color: '#fff'}}/>
        }
        </IconButton> 
    );
}



export default ProfileIcon;